var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2 bd-highlight d-block mx-auto"},[_c('p',[_c('img',{staticClass:"img-fluid d-block mx-auto",attrs:{"src":require('@/assets/details_pages/pages/' + _vm.img_src + ''),"alt":_vm.img_alt}})])])}
var staticRenderFns = []

export { render, staticRenderFns }